module.exports = __webpack_public_path__ + "static/media/electronicsIcon.8abfdcda.svg";